import React from "react";
import save from "../../../images/admin/diskette-32px.png";

import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../../css/Admin.css";
import history from "../../history";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";

import { ToastContainer, toast } from "react-toastify";
import AppConfig from "../../../config";

const appName = ""; ///ArchicubedWeb //Production
//const appName = "/"; Development
const LoadAgencyFees = (section) => {
  history.push(appName + "/admin" + (section != "" ? "/" + section : ""));
};

class PlanPage extends React.Component {
  state = {
    countries: [],
    buyingAgencies: [],
    campaigns: [],
    formats: [],
    positions: [],
    medias: [],
    submedias: [],
    vehicles: [],
    products: [],
    productcategorys: [],
    targets: [],
  };
  constructor(props) {
    super(props);
  }

  fetchCountries() {
    let initialcountries = [];
    fetch("http://localhost:86/countrymicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.countries = data;
        initialcountries = data;
        this.setState({
          countries: initialcountries,
        });
      });
  }
  fetchBuyingAgency() {
    let initialbuyingagencies = [];
    fetch("http://localhost:86/buyingagencymicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.buyingAgencies = data;
        initialbuyingagencies = data;
        this.setState({
          buyingAgencies: initialbuyingagencies,
        });
      });
  }
  fetchCampaign() {
    let initialcampaigns = [];
    fetch("http://localhost:86/campaignmicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.campaigns = data;
        initialcampaigns = data;
        this.setState({
          campaigns: initialcampaigns,
        });
      });
  }

  fetchFormat() {
    let initialformats = [];
    fetch("http://localhost:86/formatmicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.formats = data;
        initialformats = data;
        this.setState({
          formats: initialformats,
        });
      });
  }
  fetchPosition() {
    let initialpositions = [];
    fetch("http://localhost:86/positionmicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.positions = data;
        initialpositions = data;
        this.setState({
          positions: initialpositions,
        });
      });
  }
  fetchMedia() {
    let initialmedias = [];
    fetch("http://localhost:86/mediamicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.medias = data;
        initialmedias = data;
        this.setState({
          medias: initialmedias,
        });
      });
  }
  fetchSubmedia() {
    let initialsubmedias = [];
    fetch("http://localhost:86/submediamicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.submedias = data;
        initialsubmedias = data;
        this.setState({
          submedias: initialsubmedias,
        });
      });
  }
  fetchVehicle() {
    let initialvehicles = [];
    fetch("http://localhost:86/vehiclemicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.vehicles = data;
        initialvehicles = data;
        this.setState({
          vehicles: initialvehicles,
        });
      });
  }
  fetchTarget() {
    let initialtargets = [];
    fetch("http://localhost:86/targetmicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.targets = data;
        initialtargets = data;
        this.setState({
          targets: initialtargets,
        });
      });
  }
  fetchProduct() {
    let initialproducts = [];
    fetch("http://localhost:86/productmicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.products = data;
        initialproducts = data;
        this.setState({
          products: initialproducts,
        });
      });
  }
  fetchProductCategory() {
    let initialproductcategorys = [];
    fetch("http://localhost:86/productcategorymicroservice")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.productcategorys = data;
        initialproductcategorys = data;
        this.setState({
          productcategorys: initialproductcategorys,
        });
      });
  }

  componentDidMount() {
    this.fetchCountries();
    this.fetchBuyingAgency();
    this.fetchCampaign();
    this.fetchFormat();
    this.fetchMedia();
    this.fetchSubmedia();
    this.fetchPosition();
    this.fetchProduct();
    this.fetchProductCategory();
    this.fetchVehicle();
    this.fetchTarget();
  }
  onCreateUser = () => {
    let userInfo = {
      //     ins_status:this.refs.ins_status.value
      ins_local_client: this.refs.ins_local_client.value,
      ins_format: this.refs.ins_format.value,
      ins_position: this.refs.ins_position.value,
      ins_plan_owner: this.refs.ins_plan_owner.value,
      ins_media: this.refs.ins_media.value,
      ins_sub_media: this.refs.ins_sub_media.value,
      //,ins_mar_level1:this.refs.ins_mar_level1.value
      ins_mar_level5: this.refs.ins_mar_level5.value,
      ins_campaign: this.refs.ins_campaign.value,
      ins_vehicle: this.refs.ins_vehicle.value,
      ins_start_date: this.refs.ins_start_date.value,
      ins_end_date: this.refs.ins_end_date.value,
      ins_currency: this.refs.ins_currency.value,
      ins_cost: parseFloat(this.refs.ins_cost.value),
      ins_fees: parseFloat(this.refs.ins_fees.value),
      ins_net_net_cost: parseFloat(this.refs.ins_net_net_cost.value),
      ins_year: parseInt(this.refs.ins_year.value),
    };
    //192.168.30.221

    fetch(
      "http://localhost:34693/Insertion", //http://localhost:86/UserMicroservice", //http://localhost:52344/UserMicroservice",//
      {
        method: "POST",
        // mode: "no-cors",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(userInfo),
      }
    )
      .then((r) => r.json())
      .then((res) => {
        if (res) {
          toast.success("Wave is added added successfully!");
        }
      });
  };

  render() {
    let l_countries = this.state.countries;
    let optionItems = l_countries.map((planet) => (
      <option value={planet.cou_id}>{planet.cou_name}</option>
    ));

    let l_buyingagencies = this.state.buyingAgencies;
    let optionBuyingAgencies = l_buyingagencies.map((agency) => (
      <option value={agency.buyingAgencyId}>{agency.name}</option>
    ));

    let l_campaigns = this.state.campaigns;
    let optioncampaigns = l_campaigns.map((agency) => (
      <option value={agency.campaignId}>{agency.name}</option>
    ));

    let l_formats = this.state.formats;
    let optionformats = l_formats.map((agency) => (
      <option value={agency.formatId}>{agency.name}</option>
    ));

    let l_medias = this.state.medias;
    let optionmedias = l_medias.map((agency) => (
      <option value={agency.mediaId}>{agency.name}</option>
    ));
    let l_submedias = this.state.submedias;
    let optionsubmedias = l_submedias.map((agency) => (
      <option value={agency.subMediaId}>{agency.name}</option>
    ));
    let l_positions = this.state.positions;
    let optionpositions = l_positions.map((agency) => (
      <option value={agency.positionId}>{agency.name}</option>
    ));
    let l_products = this.state.products;
    let optionproducts = l_products.map((agency) => (
      <option value={agency.productId}>{agency.name}</option>
    ));
    let l_productcategorys = this.state.productcategorys;
    let optionproductcategorys = l_productcategorys.map((agency) => (
      <option value={agency.productcategoryId}>{agency.name}</option>
    ));
    let l_vehicles = this.state.vehicles;
    let optionvehicles = l_vehicles.map((agency) => (
      <option value={agency.vehicleId}>{agency.name}</option>
    ));
    let l_targets = this.state.targets;
    let optiontargets = l_targets.map((agency) => (
      <option value={agency.targetId}>{agency.name}</option>
    ));
    return (
      <div className="App1">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>Create / Edit Insertion</span>
          </div>
          <div className="div-section-actions push">
            <button
              onClick={this.onCreateUser}
              className="btn-section-header"
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
                backgroundColor: "lightblue",
              }}
            >
              <img
                style={{ width: "16px", marginRight: "8px" }}
                src={save}
              ></img>
              <label>Save</label>
            </button>
          </div>
        </div>

        <Row className="container">
          <div className="div-body-leftside col-md-12">
            <div className="mb-3 col-md-12">
              <label className="lbl_header">Client</label>
            </div>
            <Row>
              <Form.Group className="mb-3 col-md-3" controlId="IdentityLevel">
                <Form.Label>Company</Form.Label>
                <Form.Control
                  placeholder="Identity Level"
                  as="select"
                  type="select"
                >
                  <option>{AppConfig.brandName}</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3 col-md-3" controlId="IdentityLevel">
                <Form.Label>Country</Form.Label>

                <Form.Control
                  ref="ins_local_client"
                  placeholder="Identity Level"
                  as="select"
                  type="select"
                >
                  {optionItems}
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3 col-md-3" controlId="IdentityLevel">
                <Form.Label>Agency</Form.Label>
                <Form.Control
                  ref="ins_plan_owner"
                  placeholder="Identity Level"
                  as="select"
                  type="select"
                >
                  {optionBuyingAgencies}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3 col-md-3" controlId="IdentityLevel">
                <Form.Label>Year</Form.Label>
                <Form.Control
                  ref="ins_year"
                  placeholder="Identity Level"
                  as="select"
                  type="select"
                >
                  <option>2021</option>
                  <option>2022</option>
                  <option>2023</option>
                </Form.Control>
              </Form.Group>
            </Row>
            <Row>
              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Campaign</label>
                </div>
                <Row>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Campaign Name</Form.Label>

                    <Form.Control
                      ref="ins_campaign"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optioncampaigns}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Target</Form.Label>
                    <Form.Control
                      ref="ins_target"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optiontargets}
                    </Form.Control>
                  </Form.Group>
                </Row>
              </div>

              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Marketing</label>
                </div>
                <Row>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Level 1 Axis</Form.Label>

                    <Form.Control
                      ref="ins_mar_level1"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionproductcategorys}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Level 5 Product</Form.Label>

                    <Form.Control
                      ref="ins_mar_level5"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionproducts}
                    </Form.Control>
                  </Form.Group>
                </Row>
              </div>
            </Row>

            <Row>
              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Calendar</label>
                </div>
                <Row>
                  <Form.Group className="mb-3 col-md-6" controlId="startdate">
                    <Form.Label>Start Date</Form.Label>

                    <Form.Control
                      ref="ins_start_date"
                      type="date"
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-6" controlId="enddate">
                    <Form.Label>End</Form.Label>
                    <Form.Control ref="ins_end_date" type="date"></Form.Control>
                  </Form.Group>
                </Row>
              </div>
              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Media</label>
                </div>
                <Row>
                  <Form.Group
                    className="mb-3 col-md-4"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Media</Form.Label>
                    <Form.Control
                      ref="ins_media"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionmedias}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    className="mb-3 col-md-4"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>SubMedia</Form.Label>
                    <Form.Control
                      ref="ins_sub_media"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionsubmedias}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    className="mb-3 col-md-4"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Vehicle</Form.Label>
                    <Form.Control
                      ref="ins_vehicle"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionvehicles}
                    </Form.Control>
                  </Form.Group>
                </Row>
              </div>
            </Row>

            <Row>
              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Position Details</label>
                </div>
                <Row>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Format</Form.Label>
                    <Form.Control
                      ref="ins_format"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionformats}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    className="mb-3 col-md-6"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Position</Form.Label>
                    <Form.Control
                      ref="ins_position"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      {optionpositions}
                    </Form.Control>
                  </Form.Group>
                </Row>
              </div>
              <div class="col-md-6">
                <div className="mb-3 col-md-12">
                  <label className="lbl_header">Media Costs</label>
                </div>
                <Row>
                  <Form.Group
                    className="mb-3 col-md-3"
                    controlId="IdentityLevel"
                  >
                    <Form.Label>Currency</Form.Label>
                    <Form.Control
                      ref="ins_currency"
                      placeholder="Identity Level"
                      as="select"
                      type="select"
                    >
                      <option>Euro</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-3" controlId="Net">
                    <Form.Label>Net</Form.Label>
                    <Form.Control
                      ref="ins_cost"
                      placeholder="Net"
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group className="mb-3 col-md-3" controlId="Fees">
                    <Form.Label>Fees(%)</Form.Label>
                    <Form.Control
                      ref="ins_fees"
                      placeholder="Fees"
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group className="mb-3 col-md-3" controlId="NetNet">
                    <Form.Label>Net Net</Form.Label>
                    <Form.Control
                      ref="ins_net_net_cost"
                      placeholder="Net Net"
                    ></Form.Control>
                  </Form.Group>
                </Row>
              </div>
            </Row>
          </div>
        </Row>
      </div>
    );
  }
}

export default PlanPage;
